function initializeOnePageNavs() {
  if (!document.body.classList.contains("onepager")) return;

  import("purejs_onepagenav").then(({ default: OnePageNav }) => {
    // https://github.com/M-Zoldak/PureJS_OnePageNav/wiki/Configuration

    new OnePageNav({
      navLinksSelector:
        "body.onepager #header .main-nav .level_1 a:not(.invisible)",
      defaultLinkActive: true,
      updateATagClass: false,
      parentsObtainingActiveClass: ["li"],
      changeOffset: 33,
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initializeOnePageNavs();
});
